import { PapiGallection } from '@wix/da-papi-types';

export const isPremiumGallection = (gallection: PapiGallection) => !!gallection?.premiumFolderData;

export const getPremiumGallectionType = (gallection: PapiGallection) =>
  gallection?.premiumFolderData?.type;
